import { put } from 'redux-saga/effects'
import { IPcr } from '../../../pcr/store/pcr.types'
import { setNeuro } from '../store/neuro.actions'
import { getSelectedDataFromObject } from '../../../../utilities/data.util'
import { neuroPrAssess, neuroPrNabc, _featureRefKey } from '../store/neuro.reducers'

export function* getNeuro(pcrDoc: IPcr) {
  if (pcrDoc && pcrDoc.prNabc) {
    const prNabc = pcrDoc.prNabc
    const prAssess = pcrDoc?.prAssess || []
    const prAssessData = prAssess.find((prAssObj) => prAssObj._featureRefKey === _featureRefKey)
    const neuroPrStrokeScale = pcrDoc?.prStrokeScale || []
    const neuroPrNabcItems = getSelectedDataFromObject(prNabc, Object.keys(neuroPrNabc))
    const neuroPrAssessItems = getSelectedDataFromObject(prAssessData, Object.keys(neuroPrAssess))
    const neuro = {
      ...neuroPrNabcItems,
      ...neuroPrAssessItems,
      neuroPrStrokeScale,
    }
    if (neuro && Object.keys(neuro).length !== 0) {
      yield put(setNeuro(neuro))
    }
  }
}
